module.exports = __webpack_public_path__ + "img/the-taming-of-the-queen.12513f75.png";